import { render } from "./Licenses.vue?vue&type=template&id=60b6f514"
import script from "./Licenses.vue?vue&type=script&lang=js"
export * from "./Licenses.vue?vue&type=script&lang=js"

import exportComponent from "/Users/alex/lab_dev_test/info-global/info_front_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__